"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupSchedulerAttendanceSchemaProperties = exports.GroupSchedulerAttendanceSchema = exports.GroupSchedulerAttendenceStatus = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.GroupSchedulerAttendenceStatus = zod_1.z.enum([
    "cancelled",
    "invited",
    "booked",
    "joined",
]);
exports.GroupSchedulerAttendanceSchema = base_schema_1.BaseSchema.extend({
    clientId: zod_1.z.string().optional(),
    packageInstanceId: zod_1.z.string(),
    groupSchedulerId: zod_1.z.string(),
    timeslotId: zod_1.z.string().optional(),
    recurringTimeslotDate: zod_1.z.string().optional(),
    attendanceTimeslotKey: zod_1.z.string().optional(),
    joined: zod_1.z.date(),
    status: exports.GroupSchedulerAttendenceStatus,
    attending: zod_1.z.boolean(),
    statusHistory: zod_1.z.array(zod_1.z.object({
        status: exports.GroupSchedulerAttendenceStatus,
        date: zod_1.z.date(),
        reason: zod_1.z.string().optional(),
        memberId: zod_1.z.string().optional(),
        origin: zod_1.z.string().optional(),
    })),
});
exports.GroupSchedulerAttendanceSchemaProperties = {
    collectionName: "groupSchedulerAttendance",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=group-scheduler-attendance-schema.js.map